import { fromEvent } from 'rxjs';
import { tap, debounceTime } from 'rxjs/operators';
import PageNoDisplay from './PageNoDisplay';
import Pagination from './Pagination';
import { BREAKPOINTS } from '../../model/model';
import {
  isDefined,
  isNotDefined,
  truthy,
  isPhoneResolution,
  isTabletResolution,
  isMobileResolution,
  getResolution,
  notSingleEle
} from '../../utils/util';

class PromotionBanner {
  constructor(options) {
    const _ = this;

    if (!options) return;

    // import tram
    require('../../vendor/tram-v0.8.3/tram');

    _.option = $.extend(
      {
        wrap: null,
        rollingInterval: 0,
        breakpoint: BREAKPOINTS,
        global: window,
        data: null
      },
      options
    );

    _.global = _.option.global ? _.option.global : window;

    _.isMobileEnv =
      $('body').hasClass('mobile') || $('body').hasClass('tablet');

    _.wrap = null;
    _.slickWrap = null;

    _.slickWrapOuterHtml = '';
    _.currentResolution = '';

    // pageNo
    _.pageNoDisplay = null;
    _.currentPageNo = 0;
    _.totalPageNo = 0;

    // pagination
    _.pagination = null;

    // promotion list toggled
    _.promotionListAll = null;

    // banner rolling interval
    _.rollingBannerIntervalId = null;

    // fix iPad Chrome resize, orientationchange delay bug
    _.subscribeResizeWindow$ = null;
  }

  init() {
    const _ = this;
    _.wrap = $(_.option.wrap);

    // console.log('# promontionbanner.js init() _.option.wrap : ', _.option.wrap);
    // _.option.data
    let tmpl_bannerItem = _.option.data.items.map( (item, i) => {
      return `
        <li>
          <div class="bg-mobile" data-lazy="${item.bannerMobile}"></div>
          <div class="bg" data-lazy="${item.bannerPC}"></div>
          <div class="article">
              <a href="${item.url}" class="${item.target}">
                ${item.flag ?  `<span class="type is-type">${item.flagTitle}}</span>` : `<span class="type"></span>`}
                <strong class="title">${item.title}</strong>
                <span class="desc">${item.desc}</span>
                <span class="date">${item.date}</span>
              </a>
          </div>
        </li>  
      `;
    }).join('');

    let tmpl_navItem = _.option.data.items.map( (item, i) => {
      return `
        <li><a href="#">${item.shortTitle}</a></li> `;
    }).join('');

    let tmpl_listallItem = _.option.data.items.map( (item, i) => {
      return `
        <li><a href="${item.url}"><img src="${item.thumbnail}" class="thumb"><div class="article">
            <strong class="subject">${item.shortTitle}</strong><span class="date">${item.date}</span></div></a></li> `;
    }).join('');

    let tmpl = `
		<div class="section-promotion__list banner-wrap">
		<ul>
		${tmpl_bannerItem}
		</ul>
		</div>
        <div class="pagination-wrap">
            <div class="page-no">
                <span class="current">0</span>
                <span class="divider">/</span>
                <span class="total">0</span>
            </div>
            <button type="button" class="btn-prev-mobile">prev</button>
            <button type="button" class="btn-next-mobile">next</button>
            <div class="pagination-mobile">
                <div class="handle">
                    <ul class="btns">
                    ${tmpl_navItem}
                    </ul>
                </div>
            </div>
            <div class="pagination-pc">
                <ul class="btns">
                ${tmpl_navItem}
                </ul>
                <button type="button" class="btn-prev">prev</button>
                <button type="button" class="btn-next">next</button>
            </div>
        </div>
  
        <div class="section-promotion__listall">
            <div class="bundle">
                <button class="btn-listall"></button>
                <div class="wrap-listall">
                <ul>
                ${tmpl_listallItem}
                </ul>
                </div>
            </div>
        </div>
    `;

    _.option.wrap.empty().append(tmpl);

    _.setInstance();

  }
  setInstance() {
    const _ = this;

    _.wrap = $(_.option.wrap);

    if (notSingleEle(_.wrap)) return _;

    _.slickWrap = $('.section-promotion__list ul', _.wrap);

    let bannerItems = $('li', _.slickWrap);
    if (bannerItems.length <= 0) return _;

    _.slickWrapOuterHtml = _.slickWrap
      .clone()
      .wrapAll('<div />')
      .parent()
      .html();
    _.currentResolution = getResolution(_.option.breakpoint, _.global);

    _.currentPageNo = 1;
    _.totalPageNo = bannerItems.length;

    _.promotionListAll = $('.section-promotion__listall', _.wrap);

    _.addEvent();

    return _;
  }

  addEvent() {
    const _ = this;

    _.showWrap();

    _.setPromotionListAll();

    _.setPageNoDisplay();
    _.setPagination();

    _.resetBannerByBreakPoint(_.currentResolution);
    _.setBanner(_.currentPageNo);

    _.setPageNo(_.currentPageNo, _.totalPageNo);
    _.activatePagination(_.currentPageNo);

    _.setPromotionBannerRolling();

    if (_.isMobileEnv) {
      // trigger mobile device browser resize delay
      _.subscribeResizeWindow$ = fromEvent(window, 'resize')
        .pipe(
          debounceTime(100),
          tap(evt => _.resize())
        )
        .subscribe();
    } else {
      $(_.global).on('resize orientationchange', $.proxy(_.resize, _));
    }

    _.resize();
  }

  setPromotionListAll() {
    const _ = this;

    $('.btn-listall', _.promotionListAll).on('click', evt => {
      evt.preventDefault();

      const isWrapVisible = _.promotionListAll.hasClass('on');
      _.showPromotionList(!isWrapVisible);
    });
  }

  showPromotionList(flag) {
    truthy(flag)
      ? this.promotionListAll.addClass('on')
      : this.promotionListAll.removeClass('on');
  }

  setPageNoDisplay() {
    const _ = this;

    _.pageNoDisplay = new PageNoDisplay({
      wrap: $('.pagination-wrap .page-no', _.wrap)
    }).init();
  }

  setPagination() {
    const _ = this;

    _.pagination = new Pagination({
      wrap: $('.pagination-wrap', _.wrap),
      breakpoint: _.option.breakpoint,
      isMobileEnv: _.isMobileEnv,
      global: _.global
    }).init();

    $(_.pagination).on(
      Pagination.CLICK_PAGE_BTN,
      $.proxy(_.activateBannerByPagination, _)
    );
  }

  resetBannerByBreakPoint(resolution) {
    const _ = this;

    _.destroySlickWrap();

    // replace <div> has .bg, .bg-mobile class to <img>. for slick's lazy load. (slick's lazy load feature can apply only to <img>.)
    let slickWrap = $('.section-promotion__list ul', _.wrap),
      items = $('li', slickWrap),
      bg = null,
      bgMobile = null;

    if (isPhoneResolution(resolution)) {
      console.log('phone');

      // phone resolution
      for (let i = 0, max = items.length; i < max; i++) {
        bgMobile = $('.bg-mobile', items.get(i));
        bgMobile.replaceWith(
          `<img class="${bgMobile.attr('class')}" data-lazy="${bgMobile.attr(
            'data-lazy'
          )}">`
        ); // <div> to <img> has data-lazy attribute.
      }
    } else if (isTabletResolution(resolution)) {
      console.log('tablet');

      // tablet resolution
      for (let i = 0, max = items.length; i < max; i++) {
        bg = $('.bg', items.get(i));

        bgMobile = $('.bg-mobile', items.get(i));
        bgMobile.replaceWith(
          `<img class="${bgMobile.attr('class')}" data-lazy="${bg.attr(
            'data-lazy'
          )}">`
        ); // <div> to <img> has data-lazy attribute.
      }
    } else {
      console.log('pc or max');

      // pc or max resolution
      for (let i = 0, max = items.length; i < max; i++) {
        bg = $('.bg', items.get(i));
        bg.replaceWith(
          `<img class="${bg.attr('class')}" data-lazy="${bg.attr(
            'data-lazy'
          )}">`
        ); // <div> to <img> has data-lazy attribute.
      }
    }
  }

  setBanner(index = 1) {
    const _ = this;

    _.slickWrap = $('.section-promotion__list ul', _.wrap);

    _.slickWrap.on('lazyLoaded', function(event, slick, image, imageSource) {
      let img = $(image);

      if (img.length) {
        let banner = $(
          `<div class="${img.attr(
            'class'
          )}" style="background-image:url(${imageSource});"></div>`
        );
        tram(banner).set({ opacity: 0 });

        img.replaceWith(banner);

        tram(banner)
          .stop({ opacity: true })
          .add('opacity 0.5s ease-out-expo')
          .start({ opacity: 1 });
      }
    });

    _.slickWrap.on('lazyLoadError', function(event, slick, image, imageSource) {
      // error. but, try to set background image.
      const img = $(image);
      if (img.length)
        img.replaceWith(
          `<div class="${img.attr('class') ||
            ''}" style="background-image:url(${imageSource || ''});"></div>`
        );
    });

    _.slickWrap.on('beforeChange', function(
      event,
      slick,
      currentSlideIndex,
      nextSlideIndex
    ) {
      const index = nextSlideIndex + 1,
        direction = slick.currentDirection === 0 ? 'next' : 'prev';

      _.activatePagination(index, direction);

      _.currentPageNo = index;
    });

    _.slickWrap.slick({
      infinite: true,
      arrows: false,
      speed: 250,
      lazyLoad: 'ondemand',
      initialSlide: index - 1
    });

    _.slickWrap.slick('setPosition');
  }

  setPageNo(currentNo, totalNo) {
    const _ = this;

    if (isNotDefined(_.pageNoDisplay)) return;

    if (isDefined(currentNo)) _.pageNoDisplay.setCurrentNo(currentNo);

    if (isDefined(totalNo)) _.pageNoDisplay.setTotalNo(totalNo);
  }

  activatePagination(index, direction = undefined) {
    const _ = this;

    _.setPageNo(index);

    if (_.pagination && isDefined(direction))
      _.pagination.activate(index, direction);
  }

  activateBannerByPagination(
    data = { type: Pagination.CLICK_PAGE_BTN, index: 1 }
  ) {
    const _ = this,
      index = data.index;

    if (_.isSlickWrapInitialized()) {
      _.slickWrap.slick('slickGoTo', index - 1);
      _.currentPageNo = index;
    }
  }

  showWrap() {
    const _ = this;

    tram(_.wrap)
      .set({
        opacity: 0,
        visibility: 'visible'
      })
      .stop({ opacity: true })
      .add('opacity 0.5s ease-out-expo')
      .start({ opacity: 1 });
  }

  resize(evt) {
    const _ = this,
      resolution = getResolution(_.option.breakpoint, _.global);

    if (resolution !== _.currentResolution) {
      const isMobileRes = isMobileResolution(resolution),
        isCurrentMobileRes = isMobileResolution(_.currentResolution);

      if (isMobileRes && isCurrentMobileRes) {
        console.log('change between phone and tablet');

        const index = _.slickWrap.slick('slickCurrentSlide') + 1;
        _.resetBannerByBreakPoint(resolution);
        _.setBanner(index);

        _.showPromotionList(false);
      } else if (!isMobileRes && !isCurrentMobileRes) {
        console.log('change between pc and max');
      } else {
        console.log('change between phone/tablet and pc/max');

        const index = _.slickWrap.slick('slickCurrentSlide') + 1;
        _.resetBannerByBreakPoint(resolution);
        _.setBanner(index);

        _.showPromotionList(false);
      }

      _.currentResolution = resolution;
    }

    // _.currentResolution = resolution;
  }

  destroySlickWrap() {
    const _ = this;

    if (_.isSlickWrapInitialized()) {
      // destroy slick.
      _.slickWrap.off('lazyLoaded');
      _.slickWrap.off('lazyLoadError');
      _.slickWrap.slick('unslick');

      // reset slickWrap html.
      _.slickWrap.replaceWith(_.slickWrapOuterHtml);
    }
  }

  isSlickWrapInitialized() {
    const _ = this;

    if (_.slickWrap && _.slickWrap.length)
      return _.slickWrap.hasClass('slick-initialized');
    return false;
  }

  setPromotionBannerRolling() {
    const _ = this;

    if (_.totalPageNo <= 1) return;

    _.setRollingBannerInterval(
      true,
      _.option.rollingInterval,
      _.activateNextPromotionBanner
    );

    // set interaction
    if (_.isMobileEnv === true) {
      _.wrap
        .on('touchstart.ui.promotionbanner', evt => {
          _.setRollingBannerInterval(false);
        })
        .on('touchend.ui.promotionbanner', evt => {
          _.setRollingBannerInterval(
            true,
            _.option.rollingInterval,
            _.activateNextPromotionBanner
          );
        });
    } else {
      _.wrap
        .on('mouseover.ui.promotionbanner', evt => {
          _.setRollingBannerInterval(false);
        })
        .on('mouseout.ui.promotionbanner', evt => {
          _.setRollingBannerInterval(
            true,
            _.option.rollingInterval,
            _.activateNextPromotionBanner
          );
        });
    }
  }

  setRollingBannerInterval(flag, interval, callback) {
    const _ = this;

    if (isDefined(_.rollingBannerIntervalId)) {
      _.global.clearInterval(_.rollingBannerIntervalId);
      _.rollingBannerIntervalId = null;
    }

    if (truthy(flag)) {
      _.rollingBannerIntervalId = _.global.setInterval(() => {
        if (callback) callback.apply(_, []);
      }, interval);
    }
  }

  activateNextPromotionBanner() {
    const _ = this;

    _.currentPageNo++;
    if (_.currentPageNo > _.totalPageNo) _.currentPageNo = 1;

    _.slickWrap.slick('slickGoTo', _.currentPageNo - 1);
  }
}

export default PromotionBanner;



// WEBPACK FOOTER //
// ./_src/js/main/promotionBanner/PromotionBanner.js